import "./TimelineItem.scss";
import { ReactNode } from "react";

export const TimelineItem = (props: { date: string; children: ReactNode }) => (
  <div className="timeline-item">
    <div className="timeline-item-date">{props.date}</div>
    <div className="timeline-item-text">{props.children}</div>
  </div>
);
